import { useTranslation } from 'react-i18next';
import { TourFigureFrame } from './TourFigureFrame';

const K = 'tours.logistics.figures.scheduler';

/**
 * The Scheduler's task Stock tab, drawn rather than screenshotted: every
 * label is an i18n key, so the picture follows the selected language, and
 * the strokes use the app's tokens. Five labels, no sentences (spec §Figures).
 */
export function SchedulerStockFigure() {
  const { t } = useTranslation();
  return (
    <TourFigureFrame width={320} height={150} alt={t(`${K}.alt`)}>
      <text x="22" y="34" fontSize="11" fontWeight="600" fill="var(--navy)">{t(`${K}.task`)}</text>
      <g fontSize="9" fontWeight="600">
        <text x="22" y="58" fill="var(--status-planned-text)">{t(`${K}.tabStock`)}</text>
        <rect x="22" y="61" width="34" height="2" fill="var(--blue)" />
      </g>
      <rect x="22" y="78" width="276" height="44" rx="6" fill="var(--g50)" />
      <text x="32" y="95" fontSize="10" fontWeight="600" fill="var(--navy)">{t(`${K}.material`)}</text>
      <text x="32" y="109" fontSize="9" fill="var(--color-error)">{t(`${K}.line`)}</text>
      <rect x="220" y="88" width="68" height="20" rx="10" fill="var(--status-planned-bg)" stroke="var(--g100)" />
      <text x="254" y="101" fontSize="9" fontWeight="600" fill="var(--status-planned-text)" textAnchor="middle">{t(`${K}.order`)}</text>
      <g transform="translate(254 124)" stroke="var(--blue)" strokeWidth="1.5" fill="none">
        <path d="M0 0v10" /><path d="M-4 7l4 5 4-5" />
      </g>
    </TourFigureFrame>
  );
}
